import { SuggestionWithIdAndValue } from '../ComboboxTypes';

const filterInSuggestions = (suggestions: SuggestionWithIdAndValue[], value: string) =>
    suggestions.filter(
        (suggestion) =>
            suggestion.value.toLocaleLowerCase().includes(value.toLowerCase()) ||
            suggestion.label?.toLowerCase().includes(value.toLowerCase()),
    );

export const findInSuggestions = (suggestions: SuggestionWithIdAndValue[], value: string) =>
    suggestions.find(
        (suggestion) =>
            suggestion.value.toLocaleLowerCase().includes(value.toLowerCase()) ||
            suggestion.label?.toLowerCase().includes(value.toLowerCase()),
    );

export default filterInSuggestions;
